import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { run } from "../lib/util";
import { Btn } from "../components/kit";
import { useSchool } from "./ctx";

const OPTS = [1.2, 1.5, 2, 2.5, 3];

export default function AdjustSetting({ settings }) {
  const { month, bump } = useSchool();
  const [on, setOn] = useState(settings.enabled);
  const [max, setMax] = useState(settings.max);
  useEffect(() => {
    setOn(settings.enabled);
    setMax(settings.max);
  }, [settings.enabled, settings.max]);
  const dirty = on !== settings.enabled || (on && Number(max) !== Number(settings.max));
  const save = async () => {
    const body = on ? { adjust_enabled: true, adjust_max: Number(max) } : { adjust_enabled: false };
    if (await run(() => api.put(`/s/month-settings/${month}`, body), on ? `Ajuste de sobras ligado (até ×${String(max).replace(".", ",")})` : "Ajuste de sobras desligado — per capita das fichas × comensais")) bump();
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg bg-slate-50 border px-3 py-2 text-sm" data-testid="adjust-setting">
      <label className="flex items-center gap-2 font-semibold text-[#0B192C] cursor-pointer">
        <input type="checkbox" data-testid="adjust-enabled-toggle" className="w-4 h-4 accent-[#FF6500]" checked={on} onChange={(e) => setOn(e.target.checked)} />
        Aumentar o per capita para usar sobras
      </label>
      {on && (
        <label className="flex items-center gap-2 text-slate-600">
          até
          <select data-testid="adjust-max-select" className="border rounded-md px-2 py-1 bg-white" value={max} onChange={(e) => setMax(Number(e.target.value))}>
            {[...new Set([...OPTS, Number(max)])].sort((a, b) => a - b).map((o) => <option key={o} value={o}>×{String(o).replace(".", ",")} ({Math.round((o - 1) * 100)}% a mais)</option>)}
          </select>
        </label>
      )}
      {!on && <span className="text-xs text-slate-500">Desligado: usa exatamente o per capita das fichas × comensais; a sobra fica no estoque final.</span>}
      {dirty && <Btn data-testid="adjust-save-button" onClick={save}>Aplicar</Btn>}
    </div>
  );
}
